import React from "react";
import { AppHeading } from "../layout/parts/app-heading";
import AppBody from "../layout/parts/app-body";
import { useParams } from "react-router-dom";
import useApiRequest from "../hooks/use-api-request";
import ImageWithFallback from "../components/image-with-fallback";
import AvodPreviewMeta from "./avod-preview/avod-preview-meta";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";

export default function PlaylistPreviewPage() {
  const [playlist, setPlaylist] = React.useState();
  const [activeProgram, setActiveProgram] = React.useState();
  const [series, setSeries] = React.useState();
  const { id, version } = useParams();

  const { isLoading, response } = useApiRequest(`feeds/avod/playlists/${id}`); // fetches latest (published) playlist version

  React.useEffect(() => {
    if (!isLoading) {
      setPlaylist(response.data);
      if (response?.data?.playlist.length) {
        setActiveProgram(response.data.playlist[0]);
      }
    }
  }, [isLoading, response.data]);

  function onItemHover(event, program) {
    setActiveProgram(program);

    const element = event.target;
    if (!element.classList.contains("selected")) {
      element.classList.add("selected");
    }
  }

  function onItemExit(event) {
    const element = event.target;
    if (element.classList.contains("selected")) {
      element.classList.remove("selected");
    }
  }

  return (
    <React.Fragment>
      <AppHeading
        breadcrumbs={[
          {
            link: "/avod",
            title: "AVOD",
          },
          {
            link: "/avod/playlists",
            title: "Playlists",
          },
          {
            link: id ? `/avod/playlists/${id}/versions` : "",
            title: playlist?.playlist_name || "...",
          },
          {
            link: `/avod/playlists/${id}/versions/${version}`,
            title: `Version ${version}`,
          },
          {
            link: `/avod/playlists/${id}/versions/${version}preview`,
            title: `Preview (latest)`,
          },
        ]}
      />
      <AppBody loading={isLoading}>
        <div className="avod-preview-container">
          <div className="avod-preview-container__upper">
            <div className="avod-preview-poster">
              <img
                src={activeProgram?.posters.banner || activeProgram?.imgurl}
                alt=""
                className={!activeProgram?.posters.banner || activeProgram?.imgurl ? "image-placeholder" : ""}
              />
            </div>
            {series ? (
              <button
                className="avod-preview__back"
                onClick={() => {
                  setSeries(null);
                  setActiveProgram(playlist.playlist[0]);
                }}
              >
                <ArrowBackIosRoundedIcon />
              </button>
            ) : null}
            <AvodPreviewMeta activeProgram={activeProgram} />
          </div>
          <div className="avod-preview-container__lower">
            <div className="avod-preview">
              {series ? (
                series.seasons.map((season, rIndex) => (
                  <div className="avod-preview-row" key={rIndex}>
                    <div className="avod-preview-row__heading">Season {season.meta.season_number}</div>
                    <div className="avod-preview-row__body">
                      <div
                        className="avod-preview-row__body__items"
                        style={{ width: `${300 * season.episodes.length}px` }}
                      >
                        {season.episodes.map((program, pIndex) => (
                          <div
                            className="avod-preview-row__item"
                            style={{ height: `${(300 * 9) / 16}px` }}
                            onMouseEnter={(e) => onItemHover(e, program)}
                            onMouseLeave={(e) => onItemExit(e)}
                            key={pIndex}
                          >
                            <ImageWithFallback url={program.posters.landscape || program.imgurl} />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="avod-preview-row">
                  <div className="avod-preview-row__heading">{playlist?.label || "Unlabeled"}</div>
                  <div className="avod-preview-row__body">
                    <div
                      className="avod-preview-row__body__items"
                      style={{ width: `${300 * playlist?.playlist?.length}px` }}
                    >
                      {playlist?.playlist.map((program, pIndex) => (
                        <div
                          className="avod-preview-row__item"
                          style={{ height: `${(300 * 9) / 16}px` }}
                          onClick={() => {
                            if (program.meta.type === "series") {
                              setSeries(program);
                            }
                          }}
                          onMouseEnter={(e) => onItemHover(e, program)}
                          onMouseLeave={(e) => onItemExit(e)}
                          key={pIndex}
                        >
                          <ImageWithFallback url={program.posters.landscape || program.imgurl} />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </AppBody>
    </React.Fragment>
  );
}
